// const httpss = 'http://localhost:5002';
// const httpss = 'https://ticket.myu.vn';
// const httpss = 'https://mail.myu.vn';
const httpss = 'https://dashboard.myu.vn';

export {httpss};